import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  CardContent,
  Container,
  Stack,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Button,
  Grid,
  TableHead,
  TableRow,
  TablePagination,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,IconButton,
  Box,
} from "@mui/material";
import { ZoomIn, ZoomOut } from "@mui/icons-material";
import Scrollbar from "../components/Scrollbar";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { getVehicalTracking } from "src/api/vehicles";
import * as XLSX from "xlsx";
import Page from "src/components/Page";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers";

const VehicalTrackingInfo = () => {
  const [vehicleData, setVehicalData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const [selectedImage, setSelectedImage] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);


  const [fromDate, setFromDate] = useState(dayjs().startOf("day"));
  const [toDate, setToDate] = useState(dayjs().endOf("day"));


  const [zoom, setZoom] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [dragging, setDragging] = useState(false);
  const [start, setStart] = useState({ x: 0, y: 0 });

  // Zoom In and Out
  const handleZoom = (delta) => {
    setZoom((prev) => Math.max(1, Math.min(prev + delta, 3))); // Limit zoom between 1x to 3x
  };

  // Handle Mouse Scroll for Zoom
  const handleWheel = (e) => {
    e.preventDefault();
    handleZoom(e.deltaY < 0 ? 0.1 : -0.1);
  };

  // Handle Mouse Drag
  const handleMouseDown = (e) => {
    setDragging(true);
    setStart({ x: e.clientX - position.x, y: e.clientY - position.y });
  };

  const handleMouseMove = (e) => {
    if (dragging) {
      setPosition({ x: e.clientX - start.x, y: e.clientY - start.y });
    }
  };

  const formatDateTime = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};


  const handleMouseUp = () => {
    setDragging(false);
  };

  const fromDateRef = useRef(fromDate);
  const toDateRef = useRef(toDate);

  // keep refs synced
  useEffect(() => {
      fromDateRef.current = fromDate;
      toDateRef.current = toDate;
  }, [fromDate, toDate]);

  const getFilters = () => {
    let filters = {};
    let fromDatefor = fromDateRef.current;
    let toDatefor = toDateRef.current;
    filters.from_date = formatDateTime(new Date(fromDatefor), 'yyyy-MM-dd HH:mm:SS');
    filters.to_date = formatDateTime(new Date(toDatefor), 'yyyy-MM-dd HH:mm:SS');
    return filters;
  }

  const fetchVehicleTracking = () => {
    const body =  getFilters();

    getVehicalTracking(body, (response) => {
      if (response.status === 200 && response.data) {
        setVehicalData(response.data);
        setFilteredData(response.data);
      }
    });
  };

  useEffect(() => {
    handleGetReports();
  }, []);
  

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchText(query);
    const filtered = vehicleData.filter((item) =>
      item.devicename?.toLowerCase().includes(query)
    );
    setFilteredData(filtered);
  };

  const handleGetReports = () => {
    fetchVehicleTracking();
  };

  const handleExportExcel = () => {
    if (!vehicleData || vehicleData.length === 0) {
      alert("No data to Export.");
      return;
    }

    const headers = [
      "S.No",
      "Camera Name",
      "Vehicle In Image",
      "Vehicle In Time",
      "Vehicle Out Image",
      "Vehicle Out Time",
      "Status",
      "Vehicle Duration",
    ];

    const formattedData = vehicleData.map((item, index) => ({
      "S.No": index + 1,
      "Camera Name": item.devicename || "",
      "Vehicle In Image": item.SnapshotUrl || "",
      "Vehicle In Time": item.ObjectEntryOn || "",
      "Vehicle Out Image": item.ExitSnapshotUrl || "",
      "Vehicle Out Time": item.ObjectExitOn || "",
      "Status": item.ObjectLive === 1 ? "Arrived" : "Departed",
      "Vehicle Duration": item.duration || "",
    }));

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(formattedData, { header: headers });
    XLSX.utils.book_append_sheet(wb, ws, "Vehicle Data");
    XLSX.writeFile(wb, `Vehicle_Tracking_${new Date().toISOString()}.xlsx`);
  };

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setSelectedImage(null);
    setZoom(1); // Reset zoom to original size
    setPosition({ x: 0, y: 0 }); // Reset position to original
  };
  const handleRest =() =>{
    setZoom(1); // Reset zoom to original size
    setPosition({ x: 0, y: 0 }); // Reset position to original
  };

//1.https://service.vdointel.ai:8998/

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to first page
  };

  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Page title="Vehicle Tracking Info">
      <Container maxWidth="xxl" sx={{p:0}}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3}>
          <Typography variant="h4">Vehicle Tracking Info</Typography>
        </Stack>

        <Card>
          <CardContent>
            <Grid container spacing={2} alignItems="center" mb={1}>
              <Grid container spacing={2} sx={{ p: 2 }} alignItems="center" mb={1}>
                {/* <Grid item>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                      label="From Date"
                      value={fromDate}
                      onChange={(newValue) => setFromDate(newValue)}
                      maxDate={dayjs()}
                      renderInput={(params) => <TextField {...params} fullWidth />}
                    />
                  </LocalizationProvider>
                </Grid>

                <Grid item>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                      label="To Date"
                      value={toDate}
                      onChange={(newValue) => setToDate(newValue)}
                      minDate={fromDate}
                      maxDate={dayjs()}
                      renderInput={(params) => <TextField {...params} fullWidth />}
                    />
                  </LocalizationProvider>
                </Grid> */}


                <Grid item>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="From Date"
                            value={fromDate}
                            onChange={(newValue) => setFromDate(newValue)}
                            maxDate={dayjs()}
                            renderInput={(params) => <TextField {...params} fullWidth />}
                          />
                      </LocalizationProvider>
                </Grid>

                <Grid item>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="To Date"
                      value={toDate}
                      onChange={(newValue) => setToDate(newValue)}
                      minDate={fromDate}
                      maxDate={dayjs()}
                      renderInput={(params) => <TextField {...params} fullWidth />}
                    />
                  </LocalizationProvider>
                </Grid>


                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleGetReports}
                    startIcon={<InsertDriveFileIcon />}
                  >
                    Get Report
                  </Button>
                </Grid>

                {paginatedData.length > 0 && (
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleExportExcel}
                      startIcon={<InsertDriveFileIcon />}
                    >
                      Export to Excel
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Grid>

            <Grid container spacing={2} sx={{ p: 2 }} alignItems="center" mb={1}>
              <Grid item xs={3}>
                <TextField
                  label="Search by Camera Name"
                  variant="outlined"
                  value={searchText}
                  onChange={handleSearch}
                  fullWidth
                />
              </Grid>
            </Grid>

            <Scrollbar>
              <TableContainer>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell>S.No</TableCell>
                      <TableCell>Camera Name</TableCell>
                      <TableCell>Vehicle In Image</TableCell>
                      <TableCell>Vehicle In Time</TableCell>
                      <TableCell>Vehicle Out Image</TableCell>
                      <TableCell>Vehicle Out Time</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Vehicle Duration</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                  {paginatedData.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={9} align="center">
                          <Typography variant="h6" color="#ffffff">
                            No Data
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ) : (
                    paginatedData.map((item, index) => (
                      <TableRow key={index}>
                      <TableCell>{page * rowsPerPage + index + 1}</TableCell>                    
                      <TableCell>{item.devicename}</TableCell>
                        <TableCell>
                          {item?.SnapshotUrl ? (
                            <img
                              src={item?.SnapshotUrl}
                              alt="Entry Snapshot"
                              style={{ width: 50, cursor: "pointer" }}
                              onClick={() => handleImageClick(item?.SnapshotUrl)}
                            />
                          ) : (
                            "N/A"
                          )}
                        </TableCell>
                        <TableCell> {item.ObjectEntryOn ? item.ObjectEntryOn.split(".")[0] : "N/A"}</TableCell>
                        <TableCell>
                          {item?.ExitSnapshotUrl ? (
                            <img
                              src={item?.ExitSnapshotUrl}
                              alt="Exit Snapshot"
                              style={{ width: 50, cursor: "pointer" }}
                              onClick={() => handleImageClick(item?.ExitSnapshotUrl)}
                            />
                          ) : (
                            "N/A"
                          )}
                        </TableCell>
                        
                        <TableCell>{item.ObjectExitOn ? item.ObjectExitOn.split(".")[0] : "N/A"}</TableCell>
                        <TableCell>{item.ObjectLive === 1 ? "Arrived" : "Departed"}</TableCell>
                        <TableCell>{item.duration || "N/A"}</TableCell>
                      </TableRow>
                    ))
                  )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[10, 25, 50]}
              component="div"
              count={filteredData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </CardContent>
        </Card>

        {/* Dialog for Image Preview */}
        {/* <Dialog open={dialogOpen} onClose={handleCloseDialog}>
          <DialogTitle>Image Preview</DialogTitle>
          <DialogContent>
            {selectedImage && (
              <Box component="img" src={selectedImage} alt="Snapshot" sx={{ width: "100%" }} />
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog} color="error"  variant="contained">
            Close
            </Button>
          </DialogActions>
        </Dialog> */}
 <Dialog
      aria-labelledby="image-preview-dialog"
      open={dialogOpen}
      onClose={handleCloseDialog}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle id="image-preview-dialog">Image Preview</DialogTitle>
      <DialogContent
        // sx={{
        //   display: "flex",
        //   justifyContent: "center",
        //   alignItems: "center",
        //   overflow: "hidden",
        //   position: "relative",
        //   cursor: dragging ? "grabbing" : "grab",
        // }}
        onWheel={handleWheel}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
      >

{selectedImage && (
            <Box component="img" src={selectedImage} alt="Snapshot" sx={{ width: "100%", maxHeight: "80vh", transform: `scale(${zoom}) translate(${position.x}px, ${position.y}px)`,
            transition: dragging ? "none" : "transform 0.3s ease-in-out"}} />
          )}
      </DialogContent>
      <DialogActions sx={{ justifyContent: "space-between" }}>
        {/* Zoom Controls */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <IconButton onClick={() => handleZoom(-0.2)} disabled={zoom <= 1}>
            <ZoomOut />
          </IconButton>
          <Typography variant="body2">{Math.round(zoom * 100)}%</Typography>
          <IconButton onClick={() => handleZoom(0.2)} disabled={zoom >= 3}>
            <ZoomIn />
          </IconButton>
            <Button onClick={handleRest} variant="contained" color="primary">
            reset
          </Button>
        </Box>
        {/* Close Button */}
        <Button onClick={handleCloseDialog} color="error" variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>


      </Container>
    </Page>
  );
};

export default VehicalTrackingInfo;

